import Rank from "../../components/Rank/Index";
import NavSettings from "../../components/common/NavSettings";

const RankPage = () => {
  return (
    <>
      <NavSettings title="Mis Rangos" route="Inicio" active="Rangos" />

      <Rank />
    </>
  );
};

export default RankPage;
